import React from 'react'

export const DismissalCheckInIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#333333', size = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke={color}
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <title>Dismissal Check-in</title>
    {/* The location pin shape */}
    <path d='M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z' />

    {/* The checkmark inside */}
    <path d='m9 12 2 2 4-4' />
  </svg>
)
